export default __webpack_public_path__ + "static/media/2021-03-17-20-55-40-344 - 212 SREESHA GUPTA.9cc93577.jpg";